// Color Library API endpoints

import { Palette, SavePaletteResponse } from '@/types/ColorLibraryModel';
import { buildAPIUrl, responseInterceptor } from '.';

export const loadColorLibrary = async () => {
  try {
    const response = await fetch('/api/umbraco/Api/colourLibrary/list');
    const result = await response.json();
    if (response.ok && result.success) {
      // Map API data to expected format
      const mappedResult = {
        ...result.result,
        colours:
          result.result.colours?.map((color: any) => ({
            ...color,
            id: color.id || color.colourId,
            hexCode: color.hexCode?.replace('#', ''),
            seasons: color.seasons || [],
          })) || [],
      };
      return mappedResult;
    }
    throw new Error('API failed');
  } catch (error) {
    console.error('API Error:', error);
  }
};

export const loadUserPalettes = async (): Promise<{ result: Palette[]; success: boolean }> => {
  const response = await responseInterceptor(await fetch(`${await buildAPIUrl()}/umbraco/Api/UserColourPalette/List`));

  return response.json();
};

export const savePalette = async (palette: Palette): Promise<SavePaletteResponse> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/UserColourPalette/Save`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(palette),
    }),
  );
  return response.json();
};

export const deletePalette = async (paletteId: string) => {
  try {
    const response = await fetch('/api/umbraco/Api/UserColourPalette/Delete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ paletteId }),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error(error);
  }
};
